<template>
  <vs-row id="appSettingsPage" vs-type="flex" vs-w="12">
    <vs-row vs-type="flex" vs-w="12" vs-justify="space-between">
      <vs-col vs-type="flex" :vs-w="isRestrictedAdmin ? 12 : 6">
        <div
          class="w-full px-3 py-2 bg-white2 sale-box-shadow half-friendly-border mr-1"
        >
          <div class="mb-2">
            <span class="text-primary bold text-medium">Pop-Up Soru Özelliği</span>
          </div>
          <form data-vv-scope="form-cake-question">
            <vs-row vs-type="flex" vs-w="12" class="mb-2">
              <span class="weight-600">Durum :</span>
              <vs-switch class="ml-2" v-model="navigationQuestion.enabled">
                <span slot="on">Aktif</span>
                <span slot="off">Pasif</span>
              </vs-switch>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" class="my-2">
              <span class="weight-600"> Soru Metni </span>
              <vs-input
                v-validate="'required|min:3'"
                name="Metin"
                placeholder="Soru Metni"
                v-model="navigationQuestion.text"
                class="w-full"
              />
              <span class="text-danger text-sm">{{
                errors.first("form-cake-question.Metin")
              }}</span>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" class="my-2">
              <span class="weight-600"> Yönlendirme Tipi : </span>
              <vs-radio
                class="mx-2"
                v-model="navigationQuestion.type"
                :vs-value="1"
              >
                Ürün
              </vs-radio>
              <vs-radio v-model="navigationQuestion.type" :vs-value="0">
                Kategori
              </vs-radio>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" class="my-2">
              <v-select
                v-if="navigationQuestion.type === 1"
                v-validate="'required'"
                name="Ürün Seçimi"
                v-model="navigationQuestion.navigationId"
                itemid="id"
                label="name"
                placeholder="Ürün Seçimi.."
                :reduce="(product) => product.id"
                :options="products"
                class="w-full"
                :clearable="false"
              />
              <span class="text-danger text-sm">{{
                errors.first("form-cake-question.Ürün Seçimi")
              }}</span>
              <v-select
                v-if="navigationQuestion.type === 0"
                v-validate="'required'"
                class="w-full"
                name="Kategori Seçimi"
                v-model="navigationQuestion.navigationId"
                itemid="id"
                label="name"
                :reduce="(category) => category.id"
                placeholder="Kategori Seçimi.."
                :options="categories"
                :clearable="false"
              />
              <span class="text-danger text-sm">{{
                errors.first("form-cake-question.Kategori Seçimi")
              }}</span>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" vs-justify="flex-end" class="mt-2">
              <vs-button
                :disabled="
                  errors.has('form-cake-question.Kategori Seçimi') ||
                  errors.has('form-cake-question.Metin')
                "
                color="success"
                @click="submitData"
                >Kaydet
              </vs-button>
            </vs-row>
          </form>
        </div>
      </vs-col>
      <vs-col vs-type="flex" vs-w="6" v-if="!isRestrictedAdmin">
        <div
          class="w-full px-3 py-2 bg-white2 sale-box-shadow half-friendly-border ml-1"
        >
          <div class="mb-2">
            <span class="text-primary bold text-medium"
              >Moodfelek Hediye Geçerlilik Süresi</span
            >
          </div>
          <form data-vv-scope="form-moodfelek-expire">
            <vs-row vs-type="flex" vs-w="12" class="mb-2">
              <span class="weight-600">Durum :</span>
              <vs-switch class="ml-2" v-model="moodfelekExpireDay.enabled">
                <span slot="on">Aktif</span>
                <span slot="off">Pasif</span>
              </vs-switch>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" class="my-2">
              <span class="weight-600"> Hediye Geçerlilik Günü </span>
              <vs-input
                v-validate="'required|min_value:1|numeric'"
                name="Moodfelek Hediye Geçerlilik Süresi"
                placeholder="Gün"
                v-model="moodfelekExpireDay.day"
                class="w-full"
              />
              <span class="text-danger text-sm">{{
                errors.first(
                  "form-moodfelek-expire.Moodfelek Hediye Geçerlilik Süresi"
                )
              }}</span>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" vs-justify="flex-end" class="mt-2">
              <vs-button
                :disabled="
                  errors.has(
                    'form-moodfelek-expire.Moodfelek Hediye Geçerlilik Süresi'
                  )
                "
                color="success"
                @click="submitMoodfelekExpireDay"
                >Kaydet
              </vs-button>
            </vs-row>
          </form>
        </div>
      </vs-col>
    </vs-row>
    <vs-row vs-type="flex" vs-w="12" class="mt-4" vs-justify="space-between" v-if="!isRestrictedAdmin">
      <vs-col vs-type="flex" vs-w="6">
        <div
          class="w-full px-3 py-2 bg-white2 sale-box-shadow half-friendly-border mr-1"
        >
          <div class="mb-2">
            <span class="text-primary bold text-medium"
              >Mood Hediye Geçerlilik Süresi</span
            >
          </div>
          <form data-vv-scope="form-private-campaign-expire">
            <vs-row vs-type="flex" vs-w="12" class="mb-2">
              <span class="weight-600">Durum :</span>
              <vs-switch
                class="ml-2"
                v-model="privateCampaignExpireDay.enabled"
              >
                <span slot="on">Aktif</span>
                <span slot="off">Pasif</span>
              </vs-switch>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" class="my-2">
              <span class="weight-600"> Hediye Geçerlilik Günü </span>
              <vs-input
                v-validate="'required|min_value:1|numeric'"
                name="Mood Hediye Geçerlilik Süresi"
                placeholder="Gün"
                v-model="privateCampaignExpireDay.day"
                class="w-full"
              />
              <span class="text-danger text-sm">{{
                errors.first(
                  "form-private-campaign-expire.Mood Hediye Geçerlilik Süresi"
                )
              }}</span>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" vs-justify="flex-end" class="mt-2">
              <vs-button
                :disabled="
                  errors.has(
                    'form-private-campaign-expire.Mood Hediye Geçerlilik Süresi'
                  )
                "
                color="success"
                @click="submitPrivateCampaignExpireDay"
                >Kaydet
              </vs-button>
            </vs-row>
          </form>
        </div>
      </vs-col>
      <vs-col vs-type="flex" vs-w="6">
        <div
          v-if="moodCost"
          class="w-full px-3 py-2 bg-white2 sale-box-shadow half-friendly-border ml-1"
        >
          <div class="mb-2">
            <span class="text-primary bold text-medium">Mood Maaliyeti</span>
          </div>
          <form data-vv-scope="form-mood-cost">
            <vs-row vs-type="flex" vs-w="12" class="my-2">
              <span class="weight-600"> Adet Maaliyeti (₺) </span>
              <vs-input
                v-validate="{
                  required: true,
                  regex: /^\d{0,10}(\.\d{0,10}){0,1}$/,
                  min_value: 0,
                }"
                name="Mood Maaliyeti"
                placeholder="Maaliyet (₺)"
                v-model="moodCost.cost"
                class="w-full"
              />
              <span class="text-danger text-sm">{{
                errors.first("form-mood-cost.Mood Maaliyeti")
              }}</span>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" vs-justify="flex-end" class="mt-2">
              <vs-button
                :disabled="errors.has('form-mood-cost.Mood Maaliyeti')"
                color="success"
                @click="submitMoodCost"
                >Kaydet
              </vs-button>
            </vs-row>
          </form>
        </div>
      </vs-col>
    </vs-row>
    <vs-row vs-type="flex" vs-w="12" class="mt-4" vs-justify="space-between" v-if="!isRestrictedAdmin">
      <vs-col vs-type="flex" vs-w="6">
        <div
          v-if="moodGiftCost"
          class="w-full px-3 py-2 bg-white2 sale-box-shadow half-friendly-border mr-1"
        >
          <div class="mb-2">
            <span class="text-primary bold text-medium"
              >Mood Hediye Maaliyeti</span
            >
          </div>
          <form data-vv-scope="form-mood-cost">
            <vs-row vs-type="flex" vs-w="12" class="my-2">
              <span class="weight-600"> Adet Maaliyeti (₺) </span>
              <vs-input
                v-validate="{
                  required: true,
                  regex: /^\d{0,10}(\.\d{0,10}){0,1}$/,
                  min_value: 0,
                }"
                name="Mood Hediye Maaliyeti"
                placeholder="Maaliyet (₺)"
                v-model="moodGiftCost.cost"
                class="w-full"
              />
              <span class="text-danger text-sm">{{
                errors.first("form-mood-gift-cost.Mood Hediye Maaliyeti")
              }}</span>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" vs-justify="flex-end" class="mt-2">
              <vs-button
                :disabled="errors.has('form-mood-gift-cost.Mood Maaliyeti')"
                color="success"
                @click="submitMoodGiftCost"
                >Kaydet
              </vs-button>
            </vs-row>
          </form>
        </div>
      </vs-col>
      <vs-col vs-type="flex" vs-w="6">
        <div
          v-if="moodGiftCost"
          class="w-full px-3 py-2 bg-white2 sale-box-shadow half-friendly-border ml-1"
        >
          <div class="mb-2">
            <span class="text-primary bold text-medium"
              >Moodfelek Periyodu</span
            >
          </div>
          <form data-vv-scope="form-moodfelek-period">
            <vs-row vs-type="flex" vs-w="12" class="my-2">
              <span class="weight-600"> Periyod (Gün) </span>
              <vs-input
                v-validate="{ required: true, numeric: true, min_value: 0 }"
                name="Moodfelek Periyod"
                placeholder="Gün"
                v-model="moodfelekPeriod.dayPeriod"
                class="w-full"
              />
              <span class="text-danger text-sm">{{
                errors.first("form-moodfelek-period.Moodfelek Periyod")
              }}</span>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" vs-justify="flex-end" class="mt-2">
              <vs-button
                :disabled="
                  errors.has('form-moodfelek-period.Moodfelek Periyod')
                "
                color="success"
                @click="submitMoodfelekPeriod"
                >Kaydet
              </vs-button>
            </vs-row>
          </form>
        </div>
      </vs-col>
    </vs-row>
  </vs-row>
</template>

<script>
import { filterProductNameList, filterCategoryList } from "@/api/Filter";
import {
  setNavigationQuestion,
  getNavigationQuestion,
  setMoodfelekExpireDay,
  getMoodfelekExpireDay,
  getPrivateCampaignExpireDay,
  setPrivateCampaignExpireDay,
  getMoodfelekPeriod,
  setMoodfelekPeriod,
  getMoodCost,
  getMoodGiftCost,
  setMoodCost,
  setMoodGiftCost,
} from "@/api/AppSettings";

export default {
  name: "AppSettings",
  computed: {
    isRestrictedAdmin() {
      return this.$isAdmin() && (this.$isCenterBranch() || this.$isRegionalCenterBranch());
    }
  },
  data() {
    return {
      moodfelekPeriod: {
        dayPeriod: 0,
      },
      navigationQuestion: {
        type: 0,
      },
      moodfelekExpireDay: {
        enabled: false,
        day: null,
      },
      privateCampaignExpireDay: {
        enabled: false,
        day: null,
      },
      products: [],
      categories: [],
      moodCost: {
        cost: 0,
      },
      moodGiftCost: {
        cost: 0,
      },
    };
  },
  methods: {
    submitMoodfelekPeriod: async function () {
      let checker;
      checker = await this.$validator.validateAll("form.moodfelek-period");
      if (checker) {
        setMoodfelekPeriod(this.moodfelekPeriod)
          .then((res) => {
            if (res && res.status === 200) {
              this.$vs.notify({
                color: "success",
                title: "Başarılı !",
                text: "Moodfelek Periyodu Güncellendi !",
              });
            } else {
              this.$vs.notify({
                color: "danger",
                title: "Hata : " + res.status,
                text: "Moodfelek Periyodu Güncellenemedi !",
              });
            }
          })
          .catch(() => {
            this.$vs.notify({
              color: "danger",
              title: "Hata !",
              text: "Sunucu Bağlantı Hatası !",
            });
          });
      }
    },
    submitPrivateCampaignExpireDay: async function () {
      let checker;
      checker = await this.$validator.validateAll(
        "form-private-campaign-expire"
      );
      if (checker) {
        setPrivateCampaignExpireDay(this.privateCampaignExpireDay)
          .then((res) => {
            if (res && res.status === 200) {
              this.$vs.notify({
                color: "success",
                title: "Başarılı !",
                text: "Mood Hediye Süresi Güncellendi !",
              });
            } else {
              this.$vs.notify({
                color: "danger",
                title: "Hata : " + res.status,
                text: "Mood Hediye Süresi Güncellenemedi !",
              });
            }
          })
          .catch(() => {
            this.$vs.notify({
              color: "danger",
              title: "Hata !",
              text: "Sunucu Bağlantı Hatası !",
            });
          });
      }
    },
    submitMoodCost: async function () {
      let checker;
      checker = await this.$validator.validateAll("form-mood-cost");
      if (checker) {
        setMoodCost(this.moodCost)
          .then((res) => {
            if (res && res.status === 200) {
              this.$vs.notify({
                color: "success",
                title: "Başarılı !",
                text: "Mood Maaliyeti Güncellendi !",
              });
            } else {
              this.$vs.notify({
                color: "danger",
                title: "Hata : " + res.status,
                text: "Mood Maaliyeti Güncellenemedi !",
              });
            }
          })
          .catch(() => {
            this.$vs.notify({
              color: "danger",
              title: "Hata !",
              text: "Sunucu Bağlantı Hatası !",
            });
          });
      }
    },
    submitMoodGiftCost: async function () {
      let checker;
      checker = await this.$validator.validateAll("form-mood-gift-cost");
      if (checker) {
        setMoodGiftCost(this.moodGiftCost)
          .then((res) => {
            if (res && res.status === 200) {
              this.$vs.notify({
                color: "success",
                title: "Başarılı !",
                text: "Mood Hediye Maaliyeti Güncellendi !",
              });
            } else {
              this.$vs.notify({
                color: "danger",
                title: "Hata : " + res.status,
                text: "Mood Hediye Maaliyeti Güncellenemedi !",
              });
            }
          })
          .catch(() => {
            this.$vs.notify({
              color: "danger",
              title: "Hata !",
              text: "Sunucu Bağlantı Hatası !",
            });
          });
      }
    },
    submitMoodfelekExpireDay: async function () {
      let checker;
      checker = await this.$validator.validateAll("form-moodfelek-expire");
      if (checker) {
        setMoodfelekExpireDay(this.moodfelekExpireDay)
          .then((res) => {
            if (res && res.status === 200) {
              this.$vs.notify({
                color: "success",
                title: "Başarılı !",
                text: "Moodfelek Hediye Süresi Güncellendi !",
              });
            } else {
              this.$vs.notify({
                color: "danger",
                title: "Hata : " + res.status,
                text: "Moodfelek Hediye Süresi Güncellenemedi !",
              });
            }
          })
          .catch(() => {
            this.$vs.notify({
              color: "danger",
              title: "Hata !",
              text: "Sunucu Bağlantı Hatası !",
            });
          });
      }
    },
    getMoodfelekPeriod() {
      getMoodfelekPeriod()
        .then((res) => {
          if (res && res.status === 200) {
            this.moodfelekPeriod = res.data;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Moodfelek Periyodu Bulunamadı !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
    getPrivateCampaignExpireDay() {
      getPrivateCampaignExpireDay()
        .then((res) => {
          if (res && res.status === 200) {
            this.privateCampaignExpireDay = res.data;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Mood Hediye Geçerlilik Süresi Bulunamadı !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
    getMoodCost() {
      getMoodCost()
        .then((res) => {
          if (res && res.status === 200) {
            this.moodCost = res.data;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Mood Maaliyeti Bulunamadı !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
    getMoodGiftCost() {
      getMoodGiftCost()
        .then((res) => {
          if (res && res.status === 200) {
            this.moodGiftCost = res.data;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Mood Hediye Maaliyeti Bulunamadı !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
    getMoodfelekExpireDay() {
      getMoodfelekExpireDay()
        .then((res) => {
          if (res && res.status === 200) {
            this.moodfelekExpireDay = res.data;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Moodfelek Hediye Geçerlilik Süresi Bulunamadı !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
    getNavigationQuestion() {
      getNavigationQuestion()
        .then((res) => {
          if (res && res.status === 200) {
            this.navigationQuestion = res.data;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Pop-Up Soru Özelliği bulunamadı !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
    submitData: async function () {
      let checker;
      checker = await this.$validator.validateAll("form-cake-question");
      if (checker) {
        setNavigationQuestion(this.navigationQuestion)
          .then((res) => {
            if (res && res.status === 200) {
              this.$vs.notify({
                color: "success",
                title: "Başarılı !",
                text: "Pop-Up Soru Özelliği Güncellendi !",
              });
            } else {
              this.$vs.notify({
                color: "danger",
                title: "Hata : " + res.status,
                text: "Pop-Up Soru Özelliği güncellenemedi !",
              });
            }
          })
          .catch(() => {
            this.$vs.notify({
              color: "danger",
              title: "Hata !",
              text: "Sunucu Bağlantı Hatası !",
            });
          });
      }
    },
  },
  created: async function () {
    this.getNavigationQuestion();
    this.getMoodfelekExpireDay();
    this.getPrivateCampaignExpireDay();
    this.getMoodCost();
    this.getMoodGiftCost();
    this.getMoodfelekPeriod();
    this.products = await filterProductNameList();
    this.categories = await filterCategoryList();
  },
};
</script>

<style></style>
